import Vue from 'vue'
import VueRouter from 'vue-router'
// const routerPush = VueRouter.prototype.push;
// VueRouter.prototype.push = function push (location, onResolve, onReject) {
//   this.history.current.meta.mt = 0;
//   if (onResolve || onReject) {
//     return routerPush.call(this, location, onResolve, onReject);
//   }
//   return routerPush.call(this, location).catch(err => err);
// };
Vue.use(VueRouter);
const routes = [
  {
    path: '/',
    name: 'index',
    redirect: '/home',
    meta: {
      name: '致医优氧'
    }
  },
  {
    path: '/home',
    name: 'homePage',
    component: () => import('../views/home.vue' /* webpackChunkName: "admin" */),
    meta: {
      name: '致医优氧'
    },
  },
  {
    path: '/rtcapp',
    name: 'rtcPage',
    component: () => import('../views/rtcHome.vue' /* webpackChunkName: "admin" */),
    meta: {
      name: '逆时舱'
    },
  },
  {
    path: '/spm',
    name: 'spmPage',
    component: () => import('../views/spm.vue' /* webpackChunkName: "admin" */),
    meta: {
      name: '致医优波'
    },
  },
  {
    path: '/about',
    name: 'aboutPage',
    component: () => import('../views/about.vue' /* webpackChunkName: "admin" */),
    meta: {
      name: '关于我们'
    },
  },
  {
    path: '/app/nschelp',
    name: 'Nschelp',
    component: () => import('../views/nscHelp.vue' /* webpackChunkName: "admin" */),
    meta: {
      name: '逆时舱帮助页面'
    },
  },
  {
    path: '/app/nschelpdetail',
    name: 'Nschelpdetail',
    component: () => import('../views/nscHelpDetail.vue' /* webpackChunkName: "admin" */),
    meta: {
      name: '逆时舱帮助页面'
    },
  },
  {path: '*', redirect: '/'}
];
/**
 * 初始化路由
 */
const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router;
